import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

import { tokenService } from '@tallo/auth';
import { AppRouteNames } from '@tallo/investor/navigation';

/**
 * Navigates away from routes that should not be accessed by authenticated users.
 * Like sign-in, reset-password, etc
 */
export function authorizedGuard(
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
) {
  if (tokenService.getToken()) {
    return next({ name: AppRouteNames.INVESTOR_PORTFOLIO });
  }

  next();
}
